import { useState } from "react";
import { Link } from "react-router-dom";
import { Compass, X } from "lucide-react";

export const WelcomeBanner = () => {
  const [hidden, setHidden] = useState(() => localStorage.getItem("welcome-dismissed") === "1");
  if (hidden) return null;
  const dismiss = () => { localStorage.setItem("welcome-dismissed", "1"); setHidden(true); };
  return (
    <div data-testid="welcome-banner" className="card mt-6 p-4 flex items-center gap-3 text-sm fade-up" style={{ borderColor: "var(--accent)" }}>
      <Compass size={18} className="shrink-0" style={{ color: "var(--accent)" }} />
      <p className="flex-1">New here? Read the 2-minute <strong>tester welcome guide</strong> on how to get the most out of RGA Trainer.</p>
      <Link to="/guide" onClick={dismiss} data-testid="welcome-banner-open" className="btn-primary h-9 px-4 rounded-full text-xs font-semibold flex items-center shrink-0">Read guide</Link>
      <button data-testid="welcome-banner-dismiss" onClick={dismiss} aria-label="Dismiss" className="btn-ghost h-8 w-8 rounded-full grid place-items-center shrink-0"><X size={14} /></button>
    </div>
  );
};
